module.exports = __webpack_public_path__ + "static/checkinn-logo-af04119b1c7420efd408449b8971ee34.png";